import { SELECTAPPLICATION } from "redux/constants/Application";

export function selectApplicationToStoreAction(payload) {
  return {
    type: SELECTAPPLICATION,
    payload,
  };
}
